import { ProjectIntro } from "shared/projects/project-shared/project-intro";
import { ProjectDesc } from "shared/projects/project-shared/project-desc";
import { Section, SectionData, Image as ImageType } from "shared/types";
import { Numbers } from "shared/numbers";
import Image from "shared/images";
import { Visit } from "shared/visit";
import { Button } from "shared/button";
import Icon from "shared/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import BayramAtlantePdf from "../../../assets/pdf/AtlanteGalattico-Bayram.pdf";
import { ProjectImage } from "../project-shared/project-image";
import { ProjectMobile } from "../project-shared/project-mobile";

export const By = (props: SectionData) => {
  const projectImageData = {
    image: "bayramDesktop" as const,
    text: "",
  };
  const projectMobileData = {
    mobile: "bayramMobile" as const,
    tablet: "bayramTablet" as const,
  };

  const slider: ImageType[] = [
    "bayram1",
    "bayram2",
    "bayram3",
    "bayram4",
    "bayram5",
    "bayram6",
    "bayram7",
    "bayram8",
    "bayram9",
    "bayram10",
    "bayram11",
    "bayram12",
    "bayram13",
    "bayram14",
    "bayram15",
    "bayram16",
  ];

  return (
    <div className="project color-black" style={{ backgroundColor: props.bg }}>
      <ProjectIntro {...props} />
      <div className="container full m-auto">
        <ProjectDesc {...props} />
        <ProjectImage {...projectImageData} />
        <ProjectMobile {...projectMobileData} />

        <Numbers data={props.numbers} section={props.section as Section} />

        <div className="bayram-download">
          <div className="text">
            Scarica “L'atlante galattico di Bayram”che raccoglie la storia, le
            immagini, i numeri e la rassegna stampa in vista delle prossime
            edizioni.
          </div>
          <div className="download visit black">
            <a
              href={BayramAtlantePdf}
              target="blank"
              download={BayramAtlantePdf}
            >
              <Button className="circle">
                <Icon name="download" className="lg" />
              </Button>
              <span> SCARICA </span>
            </a>
          </div>
        </div>
        <div className="pangea-extra">
          <div className="pangea-teatro">
            <div className="desc">
              <p>
                Bayram nasce dunque come un laboratorio di idee e visioni, un
                luogo in cui i grandi temi del nostro tempo si intrecciano e si
                ridefiniscono: la relazione tra scienza e spiritualità, la
                tecnopolitica e le sue implicazioni etiche, la geopolitica
                dell'intelligenza artificiale, l'immaginazione del futuro e la
                ricerca di un nuovo patto tra generazioni. L'iniziativa si
                propone come un viaggio nel futuro attraverso il pensiero, un
                confronto aperto tra discipline apparentemente distanti — fisica
                e teologia, poesia e tecnologia, filosofia e astrofisica — per
                riflettere su come l'umanità possa orientarsi nell'era della
                complessità. Dalle nuove frontiere dell'infosfera alla civiltà
                degli algoritmi, dal cosmismo russo al transumanesimo, fino alla
                teologia dell'immaginazione, Bayram invita il pubblico a
                interrogarsi su una domanda urgente e universale: come sarebbe
                il mondo se le cose andassero diversamente?
              </p>
            </div>
            <div className="extra">
              <Swiper slidesPerView={"auto"} className="slider-nucleo">
                {slider.map((img, i) => (
                  <SwiperSlide
                    key={i}
                    className={`${i === 12 ? "vertical" : "horizontal"}`}
                  >
                    <Image name={img} title="Bayram" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
